// extracted by mini-css-extract-plugin
export default {"modalHead":"styles_modalHead__Bb+Sj","content":"styles_content__+bP7R","text":"styles_text__uwrmk","controls":"styles_controls__CSIj1","button":"styles_button__TZe7Q"};